import { Routes, Route, Navigate } from "react-router-dom";
import { loadSavedTheme } from "./hooks/useTheme";
import LandingPage from "./pages/LandingPage/LandingPage";
// Base global (body, .card, .btn-primary, .dashboard-container...) usada pelo
// dashboard e demais rotas; antes entrava no bundle via import do Login antigo.
import "./pages/auth/index.css";
import Login from "./pages/auth/Login";
import Profile from "./pages/Profile/Profile";
import Register from "./pages/auth/Register";
import Dashboard from "./pages/Dashboard/Dashboard";
import Statistics from "./pages/Statistics/Statistics";
import Ranking from "./pages/Ranking/Ranking";
import Gateways from "./pages/Gateways/Gateways";
import Tracking from "./pages/Tracking/Tracking";
import Redirecionadores from "./pages/Redirecionadores/Redirecionadores";
import CreateBot from "./pages/Bots/Create/CreateBot";
import BotManagement from "./pages/Bots/BotManagement/BotManagement";
import FlowList from "./pages/Bots/Flows/FlowList";
import Flows from "./pages/Bots/Flows/Flows";
import DisparoPage from "./pages/Bots/Disparo/DisparoPage";
import Leads from "./pages/Leads/Leads";
import Sales from "./pages/Sales/Sales";
import Support from "./pages/Support/Support";

import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import AppLayout from "./layouts/AppLayout";
import NotFound from "./pages/404/NotFound";
import TermsOfUse from "./pages/Legal/TermsOfUse";
import ForgotPassword from "./pages/auth/password/ForgotPassword";
import ResetPassword from "./pages/auth/password/ResetPassword";
import VerifyEmail from "./pages/auth/VerifyEmail";
import ConfirmEmail from "./pages/auth/ConfirmEmail";
import Admin from "./pages/Admin/Admin";
import AdminRoute from "./routes/AdminRoute";

function App() {
  loadSavedTheme();

  return (
    <Routes>
      {/* Públicas — logado é redirecionado pro dashboard */}
      <Route element={<PublicRoute />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* Pós-cadastro: nada a fazer aqui se já está logado (=já verificado) */}
        <Route path="/confirm-email" element={<ConfirmEmail />} />
      </Route>

      {/* Acessível a todos, logado ou não */}
      <Route path="/legal/tos" element={<TermsOfUse />} />
      {/* Confirmação por link: fora do PublicRoute pra preservar a tela de
          sucesso; o próprio componente redireciona quem já está logado. */}
      <Route path="/verify-email" element={<VerifyEmail />} />

      {/* Editor de fluxo — tela cheia, sem sidebar */}
      <Route element={<PrivateRoute />}>
        <Route path='/bots/flows/:botId/edit' element={<Flows />} />
      </Route>

      {/* Protegidas com sidebar */}
      <Route element={<PrivateRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path='/profile' element={<Profile />} />
          <Route path='/statistics' element={<Statistics />} />
          <Route path='/ranking' element={<Ranking />} />
          <Route path='/gateways' element={<Gateways />} />
          <Route path='/tracking' element={<Tracking />} />
          <Route path='/redirecionadores' element={<Redirecionadores />} />
          <Route path='/leads' element={<Leads />} />
          <Route path='/sales' element={<Sales />} />
          <Route path='/suporte' element={<Support />} />
          <Route path='/bots/create' element={<CreateBot />} />
          <Route path='/bots/manage/:botId' element={<BotManagement />} />
          <Route path='/bots/flows' element={<FlowList />} />
          {/* Rota antiga por bot — agora a lista é única por usuário */}
          <Route path='/bots/flows/:botId' element={<Navigate to="/bots/flows" replace />} />
          <Route path='/disparos' element={<DisparoPage />} />
          <Route path='/bots/disparo/:botId' element={<Navigate to="/disparos" replace />} />
          {/* Redirect old routes to new unified page */}
          <Route path='/bots/edit/:botId' element={<BotManagement />} />
          <Route path='/bots/order_bump/:botId' element={<BotManagement />} />
          <Route path='/bots/downsell/:botId' element={<BotManagement />} />
          <Route path='/bots/upsell/:botId' element={<BotManagement />} />

          <Route element={<AdminRoute />}>
            <Route path='/dashboard/admin/' element={<Admin />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
